import { ENV } from '../config/env';

/**
 * Disable console methods in production
 * Call this once at app initialization
 */
export const disableConsoleInProduction = () => {
  if (ENV.NODE_ENV === 'production') {
    // Store original methods for potential debugging
    const noop = () => {};
    
    console.log = noop;
    console.debug = noop;
    console.info = noop;
    console.warn = noop;
    // Keep console.error for critical issues (optional - comment out if you want to disable too)
    // console.error = noop;
  }
};

